import { Component, Output, EventEmitter } from '@angular/core';
import { Optin } from './optin';

@Component({
  selector: 'dp-form-images',
  templateUrl: 'form-images.component.html',
  styleUrls: ['form-images.component.scss']
})
export class FormImagesComponent {
  @Output() public changefile = new EventEmitter<any>();
  public optin: Optin = new Optin();

  public getImage(event, type) {
    this.optin.images[type] = event.imageCropped;
    this.optin.originalImages[type] = event.original;
    this.optin.originalImages[`${type}Position`] = event.cropperPosition;

    this.changefile.emit(this.optin);
  }

  public removeImage(_, type) {
    delete this.optin.images[type];
    delete this.optin.originalImages[type];
    delete this.optin.originalImages[`${type}Position`];

    this.changefile.emit(this.optin);
  }
}
